import { postV2ApiCompanyIdCardsIncreaseLimitsProcedureId } from 'src/client/spendesk-api';
import { type PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest } from 'src/client/spendesk-api-types';

export type PostCardLimitsIncreaseScaOperationInput = {
  authenticationMethod: PostV2ApiCompanyIdCardsIncreaseLimitsProcedureIdRequest['body']['authenticationMethod'];
  companyId: string;
  procedureId: string;
  description: string;
};

export type CardLimitsIncreaseScaOperationOutput = {
  procedureStatus: 'pending' | 'approved' | 'rejected' | 'timeout';
  success?: boolean;
};

export const postCardLimitsIncreaseScaOperation = async ({
  authenticationMethod,
  companyId,
  procedureId,
  description,
}: PostCardLimitsIncreaseScaOperationInput): Promise<CardLimitsIncreaseScaOperationOutput> => {
  const { statusCode, body } =
    await postV2ApiCompanyIdCardsIncreaseLimitsProcedureId({
      path: {
        companyId,
        procedureId,
      },
      body: {
        authenticationMethod,
        description,
      },
    });

  if (statusCode === 200) {
    const { procedureStatus } = body;

    if (procedureStatus !== 'approved') {
      return {
        procedureStatus,
      };
    }

    return body;
  }

  if (statusCode === 500 && body.data === 'failed-to-increase-card-limits') {
    return {
      procedureStatus: 'approved',
      success: false,
    };
  }

  throw new Error('Failed to get card limits increase SCA operation status.');
};
